
import { useState } from 'react';

const TestimonialSection = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const testimonials = [
    {
      name: 'Michael Rodriguez',
      location: 'Brooklyn, NY',
      rating: 5,
      text: 'After a serious collision, I was worried about my car. The team at Brooklyn Auto Body did an amazing job! My car looks brand new and the repair was completed faster than expected. They worked directly with my insurance company and made the whole process stress-free.',
      service: 'Collision Repair',
      image: 'https://public.readdy.ai/ai/img_res/0d3d5bf66d0a05d9a4f859cf13ec7d21.jpg'
    },
    {
      name: 'Sarah Johnson',
      location: 'Park Slope, Brooklyn',
      rating: 5,
      text: 'I needed my car painted after some rust damage, and the color match is absolutely perfect! You can\'t even tell where the new paint is. The attention to detail and quality of work exceeded my expectations. Highly recommend for any auto body painting needs!',
      service: 'Auto Body Painting',
      image: 'https://readdy.ai/api/search-image?query=Professional%20African%20American%20woman%20in%20her%20thirties%20smiling%20warmly%2C%20business%20casual%20attire%2C%20confident%20friendly%20expression%2C%20natural%20lighting%2C%20clean%20simple%20background&width=400&height=400&seq=testimonial-002&orientation=squarish'
    },
    {
      name: 'David Chen',
      location: 'Sunset Park, Brooklyn',
      rating: 5,
      text: 'Got a huge dent from a parking lot incident. They used paintless dent removal and saved me hundreds of dollars! The dent is completely gone and my original paint is intact. Fast, affordable, and professional service. Will definitely come back for any future needs.',
      service: 'Dent Removal',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Asian%20man%20in%20his%20forties%20smiling%20genuinely%2C%20business%20casual%20clothing%2C%20approachable%20friendly%20demeanor%2C%20natural%20lighting%2C%20clean%20simple%20background&width=400&height=400&seq=testimonial-003&orientation=squarish'
    },
    {
      name: 'Jennifer Martinez',
      location: 'Bay Ridge, Brooklyn',
      rating: 5,
      text: 'After my accident, my car\'s frame was bent. They used computerized frame straightening equipment and restored it perfectly. The car drives straight and safe again. Their expertise and modern equipment really show in the quality of their work. Thank you!',
      service: 'Frame Straightening',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Latina%20woman%20in%20her%20late%20twenties%20smiling%20brightly%2C%20business%20casual%20attire%2C%20warm%20friendly%20expression%2C%20natural%20lighting%2C%20clean%20simple%20background&width=400&height=400&seq=testimonial-004&orientation=squarish'
    },
    {
      name: 'Robert Thompson',
      location: 'Williamsburg, Brooklyn',
      rating: 5,
      text: 'I\'ve been bringing my cars here for over 10 years. From collision repair to routine maintenance, they always deliver excellent service. Fair prices, honest work, and they treat you like family. This is the only auto body shop I trust in Brooklyn.',
      service: 'Long-time Customer',
      image: 'https://readdy.ai/api/search-image?query=Professional%20Caucasian%20man%20in%20his%20fifties%20smiling%20warmly%2C%20business%20casual%20attire%2C%20trustworthy%20friendly%20expression%2C%20natural%20lighting%2C%20clean%20simple%20background&width=400&height=400&seq=testimonial-005&orientation=squarish'
    },
    {
      name: 'Amanda Williams',
      location: 'Downtown Brooklyn',
      rating: 5,
      text: 'Had a minor fender bender and needed quick repairs. They provided a free estimate, worked with my insurance, and had my car ready in just 3 days! The repair is flawless and the customer service was outstanding. Highly recommend to anyone in Brooklyn!',
      service: 'Collision Repair',
      image: 'https://readdy.ai/api/search-image?query=Professional%20young%20Caucasian%20woman%20smiling%20cheerfully%2C%20business%20casual%20clothing%2C%20friendly%20approachable%20expression%2C%20natural%20lighting%2C%20clean%20simple%20background&width=400&height=400&seq=testimonial-006&orientation=squarish'
    }
  ];

  const nextTestimonial = () => {
    setActiveIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section className="py-16 sm:py-20 lg:py-24 bg-gradient-to-br from-gray-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-12 sm:mb-16">
          <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full mb-4 sm:mb-6">
            <i className="ri-star-fill text-lg"></i>
            <span className="text-sm font-semibold whitespace-nowrap">Customer Reviews</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6 font-['Playfair_Display'] px-4">
            What Our Customers Say
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-3xl mx-auto leading-relaxed px-4">
            Don't just take our word for it. See what our satisfied customers have to say about our collision repair and auto body services in Brooklyn.
          </p>
        </div>

        <div className="relative max-w-5xl mx-auto">
          <div className="bg-white rounded-3xl shadow-2xl p-6 sm:p-10 lg:p-12">
            <div className="flex flex-col lg:flex-row items-center gap-6 sm:gap-8 lg:gap-12">
              <div className="w-32 h-32 sm:w-40 sm:h-40 lg:w-48 lg:h-48 flex-shrink-0">
                <img
                  src={testimonials[activeIndex].image}
                  alt={testimonials[activeIndex].name}
                  className="w-full h-full object-cover rounded-2xl shadow-lg"
                />
              </div>

              <div className="flex-1 text-center lg:text-left">
                <div className="flex items-center justify-center lg:justify-start gap-1 mb-4">
                  {[...Array(testimonials[activeIndex].rating)].map((_, i) => (
                    <i key={i} className="ri-star-fill text-yellow-400 text-xl sm:text-2xl"></i>
                  ))}
                </div>

                <p className="text-base sm:text-lg lg:text-xl text-gray-700 mb-6 sm:mb-8 leading-relaxed italic">
                  "{testimonials[activeIndex].text}"
                </p>

                <div className="mb-4">
                  <h4 className="text-xl sm:text-2xl font-bold text-gray-900 mb-1">
                    {testimonials[activeIndex].name}
                  </h4>
                  <p className="text-sm sm:text-base text-gray-600">
                    {testimonials[activeIndex].location}
                  </p>
                </div>

                <div className="inline-flex items-center gap-2 bg-orange-100 text-orange-600 px-4 py-2 rounded-full">
                  <i className="ri-checkbox-circle-fill text-base"></i>
                  <span className="text-sm font-semibold whitespace-nowrap">{testimonials[activeIndex].service}</span>
                </div>
              </div>
            </div>
          </div>

          <div className="flex items-center justify-center gap-4 mt-8 sm:mt-10">
            <button
              onClick={prevTestimonial}
              className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-white hover:bg-orange-600 text-gray-700 hover:text-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
              aria-label="Previous testimonial"
            >
              <i className="ri-arrow-left-line text-xl sm:text-2xl"></i>
            </button>

            <div className="flex gap-2">
              {testimonials.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setActiveIndex(index)}
                  className={`w-2 h-2 sm:w-3 sm:h-3 rounded-full transition-all cursor-pointer ${
                    index === activeIndex ? 'bg-orange-600 w-6 sm:w-8' : 'bg-gray-300'
                  }`}
                  aria-label={`Go to testimonial ${index + 1}`}
                />
              ))}
            </div>

            <button
              onClick={nextTestimonial}
              className="w-12 h-12 sm:w-14 sm:h-14 flex items-center justify-center bg-white hover:bg-orange-600 text-gray-700 hover:text-white rounded-full shadow-lg transition-all hover:scale-110 cursor-pointer"
              aria-label="Next testimonial"
            >
              <i className="ri-arrow-right-line text-xl sm:text-2xl"></i>
            </button>
          </div>
        </div>

        <div className="text-center mt-12 sm:mt-16">
          <div className="inline-flex flex-col sm:flex-row items-center gap-4 sm:gap-6 bg-white rounded-2xl p-6 sm:p-8 shadow-lg">
            <div className="flex items-center gap-2">
              <div className="flex">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-400 text-2xl sm:text-3xl"></i>
                ))}
              </div>
              <span className="text-3xl sm:text-4xl font-bold text-gray-900">5.0</span>
            </div>
            <div className="text-center sm:text-left">
              <p className="text-base sm:text-lg font-semibold text-gray-900">Rated 5 Stars</p>
              <p className="text-sm sm:text-base text-gray-600">Based on 200+ Google Reviews</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;
